// extracted by mini-css-extract-plugin
module.exports = {"fade":"style_fade__gf8u0"};